import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import "../ClosedLoop/Dashboard.less"
import { withRouter } from "../../lib/withRouter"
import { formatDate, formatDuration, formatFileSize, getViewPatientData, postResource } from "../../lib"
import moment from "moment"
import RangePicker from "../ClaimReview/RangePicker"
import MirthXML from "./MirthXML"
import Header2 from "../Header2"
import MirthEMPI from "./MirthEMPI"

export class MirthAuditLog extends React.Component {
    static propTypes = {
        query: PropTypes.object,
        selection: PropTypes.object,
        location: PropTypes.object,
        settings: PropTypes.object,
        urlParams: PropTypes.object,
        dispatch: PropTypes.func
    };

    constructor(props) {
        super(props);
        // const startDate = moment().startOf("month").format("YYYY-MM-DD");
        // const endDate = moment().endOf("month").format("YYYY-MM-DD");
        const startDate = moment().subtract(30, "days").format("YYYY-MM-DD");
        const endDate = moment().format("YYYY-MM-DD");

        this.state = {
            selectedLog: null,
            logsList: [],
            channelsDropdown: [],
            dataTypesDropdown: [],
            summary: null,
            stats: null,
            loading: false,
            error: null,
            filters: {
                startDate: startDate,
                endDate: endDate,
                channel: 'all',
                dataType: 'all',
                status: 'all',
                patientName: ''
            },
            page: 0,
            totalPages: 0,
            totalRecords: 0,
            hasNextPage: true,
            sortConfig: {
                key: null,
                direction: "asc"
            },
            sidebarView: null, // 'detail' or 'update',
            showStats: false
        };
    }

    componentDidMount() {
        this.fetchFilterOptions();
        this.fetchLogsData();
    }

    handleSort = (key) => {
        this.setState((prevState) => {
            if (prevState.sortConfig.key !== key) {
                return {
                    sortConfig: { key, direction: "asc" }
                };
            }

            if (prevState.sortConfig.direction === "asc") {
                return {
                    sortConfig: { key, direction: "desc" }
                };
            }

            return {
                sortConfig: { key: null, direction: "asc" }
            };
        });
    };

    getSortIconClass = (key) => {
        const { sortConfig } = this.state;

        if (sortConfig.key !== key) {
            return "fa-sort text-muted";
        }

        return sortConfig.direction === "asc" ? "fa-sort-up" : "fa-sort-down";
    };

    fetchLogsData = async (page = null) => {
        try {
            this.setState({ loading: true, error: null });
            const { filters } = this.state;

            let apiUrl = `${this.props.settings.server.baseUrl}/mirth/logs?limit=100`;

            if (filters?.channel !== 'all') {
                apiUrl += `&channelName=${filters.channel}`;
            }
            if (filters?.dataType !== 'all') {
                apiUrl += `&dataType=${filters.dataType}`;
            }
            if (filters?.status !== 'all') {
                apiUrl += `&status=${filters.status}`;
            }
            if (filters?.patientName && filters?.patientName != "") {
                apiUrl += `&patientName=${filters.patientName}`;
            }
            apiUrl += `&startDate=${filters.startDate}&endDate=${filters.endDate}`;

            if (page) {
                apiUrl += `&page=${page}`;
            }

            const data = await getViewPatientData({
                url: apiUrl,
                server: this.props.settings.server
            });

            console.log('Mirth Logs', data)
            const currentPage = page ?? this.state.page;

            this.setState({
                logsList: data?.data || [],
                totalRecords: data?.totalRecords || 0,
                totalPages: data?.totalPages || 0,
                hasNextPage: currentPage < (data?.totalPages - 1),
                loading: false
            });

            this.fetchSummaryAndStats();
        } catch (error) {
            console.error("Dashboard fetch failed:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    fetchSummaryAndStats = async () => {
        try {
            // this.setState({ loading: true, error: null });

            const { filters } = this.state;

            const baseUrl = this.props.settings.server.baseUrl;

            const summaryApi = `${baseUrl}/mirth/summary?startDate=${filters.startDate}&endDate=${filters.endDate}`;
            const statsApi = `${baseUrl}/mirth/stats?startDate=${filters.startDate}&endDate=${filters.endDate}`;

            const [summaryRes, statsRes] = await Promise.all([
                getViewPatientData({
                    url: summaryApi,
                    server: this.props.settings.server
                }),
                getViewPatientData({
                    url: statsApi,
                    server: this.props.settings.server
                })
            ]);

            console.log("Summary:", summaryRes);
            console.log("Stats:", statsRes);

            this.setState({
                summary: summaryRes || [],
                stats: statsRes || []
            });

        } catch (error) {
            console.error("Dashboard fetch failed:", error);
            this.setState({ error: error.message, loading: false });
        }
    };



    handleNext = () => {
        const { page, totalPages } = this.state;

        if (page >= totalPages - 1) return;

        const nextPage = page + 1;

        this.setState(
            { page: nextPage },
            () => this.fetchLogsData(nextPage)
        );
    };

    handlePrev = () => {
        const { page } = this.state;

        if (page <= 0) return;

        const prevPage = page - 1;

        this.setState(
            { page: prevPage },
            () => this.fetchLogsData(prevPage)
        );
    };

    handleSidebar = async (log, view = 'detail') => {
        console.log("Selected Log", log)
        this.setState({
            selectedLog: log,
            sidebarView: view,
        });
    };

    fetchFilterOptions = async () => {
        try {
            this.setState({ loading: true, error: null });

            const baseUrl = this.props.settings.server.baseUrl;

            const channerDropdownApi = `${baseUrl}/mirth/channels`;
            const dataTypeDropdownApi = `${baseUrl}/mirth/data-types`;

            const [channelDropdownRes, dataTypeDropdownRes] = await Promise.all([
                getViewPatientData({
                    url: channerDropdownApi,
                    server: this.props.settings.server
                }),
                getViewPatientData({
                    url: dataTypeDropdownApi,
                    server: this.props.settings.server
                })
            ]);

            console.log("Channel Dropdown:", channelDropdownRes);
            console.log("Data type Dropdown:", dataTypeDropdownRes);

            this.setState({
                channelsDropdown: channelDropdownRes || [],
                dataTypesDropdown: dataTypeDropdownRes || [],
                loading: false
            });

        } catch (error) {
            console.error("Dashboard fetch failed:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    handleFilterChange = (filterName, value) => {
        this.setState(prev => ({
            filters: {
                ...prev.filters,
                [filterName]: value
            }
        }));
    };

    handleApplyFilters = () => {
        this.setState({ page: 0 }, () => {
            this.fetchLogsData();
        });
    };

    handleCloseSidebar = () => {
        this.setState({ selectedLog: null, sidebarView: null });
    };

    handleDateRangeChange = (start, end) => {
        this.setState(prev => ({
            filters: {
                ...prev.filters,
                startDate: moment(start).startOf("day").format("YYYY-MM-DD"),
                endDate: moment(end).endOf("day").format("YYYY-MM-DD")
            }
        }));
    };

    fetchReferralsList = () => {
        this.handleCloseSidebar();
        this.fetchLogsData();
    };

    renderFilters() {
        const { filters, channelsDropdown, dataTypesDropdown } = this.state;

        return (
            <div className="row">
                <div className="col-sm-2">
                    <div className="d-flex align-items-center">
                        <select
                            className="form-control input-sm"
                            value={filters.channel}
                            onChange={(e) => this.handleFilterChange('channel', e.target.value)}
                        >
                            <option value="all">All Channels</option>
                            {channelsDropdown?.map((item, index) => (
                                <option value={item} key={`referralType${index}`}>{item}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="col-sm-2">
                    <div className="d-flex align-items-center">
                        <select
                            className="form-control input-sm"
                            value={filters.dataType}
                            onChange={(e) => this.handleFilterChange('dataType', e.target.value)}
                        >
                            <option value="all">All Types</option>
                            {dataTypesDropdown?.map((item, index) => (
                                <option value={item} key={`referralStatus${index}`}>{item}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="col-sm-2">
                    <div className="d-flex align-items-center">
                        <select
                            className="form-control input-sm"
                            value={filters.status}
                            onChange={(e) => this.handleFilterChange('status', e.target.value)}
                        >
                            <option value="all">All Status</option>
                            <option value="1">Success</option>
                            <option value="0">Failed</option>
                        </select>
                    </div>
                </div>

                <div className="col-sm-3">
                    <div className="d-flex align-items-center justify-end">
                        <RangePicker
                            onRangeChange={this.handleDateRangeChange}
                            className={"input-sm w-100"}
                        />
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="input-group">
                        <input
                            type="text"
                            className="form-control input-sm"
                            placeholder="Search by Name..."
                            value={filters.patientName}
                            onChange={(e) => this.handleFilterChange('patientName', e.target.value)}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    this.fetchLogsData();
                                }
                            }}
                        />
                        <span className="input-group-btn">
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => {
                                    this.handleApplyFilters()
                                }}
                            >
                                <i className="fa fa-search" />
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    renderLogsList() {

        const { logsList, loading, error, hasNextPage } = this.state;

        if (loading) {
            return (
                <div className="patient-search-loading">
                    <i className="fa fa-spinner spin" /> Loading. Please wait...
                </div>
            );
        }

        if (!logsList) return null;


        if (error) {
            return <p className="text-danger">Error: {error}</p>;
        }

        const { sortConfig } = this.state;

        let sortedList = [...logsList];

        if (sortConfig.key) {
            sortedList.sort((a, b) => {
                let valA = a[sortConfig.key];
                let valB = b[sortConfig.key];

                // Handle null values
                if (!valA) return 1;
                if (!valB) return -1;

                // Handle dates
                if (sortConfig.key.includes("Date") || sortConfig.key.includes("Update")) {
                    valA = new Date(valA);
                    valB = new Date(valB);
                }

                // String comparison
                if (typeof valA === "string") {
                    valA = valA.toLowerCase();
                    valB = valB.toLowerCase();
                }

                if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
                if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;

                return 0;
            });
        }

        return (
            <div className="panel panel-default">
                <div className="table-responsive">
                    <table className="table table-striped table-bordered table-hover table-condensed">
                        <thead>
                            <tr>
                                <th style={{ width: "10%" }}>
                                    <button
                                        type="button"
                                        onClick={() => this.handleSort("patient_name")}
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            padding: 0,
                                            fontWeight: 600,
                                            cursor: "pointer"
                                        }}
                                    >
                                        Member <i className={`fa ${this.getSortIconClass("patient_name")}`} />
                                    </button>
                                </th>
                                <th style={{ width: "15%" }}>
                                    <button
                                        type="button"
                                        onClick={() => this.handleSort("channel_name")}
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            padding: 0,
                                            fontWeight: 600,
                                            cursor: "pointer"
                                        }}
                                    >
                                        Channel Name <i className={`fa ${this.getSortIconClass("channel_name")}`} />
                                    </button>
                                </th>
                                <th style={{ width: "10%" }}>
                                    <button
                                        type="button"
                                        onClick={() => this.handleSort("data_type")}
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            padding: 0,
                                            fontWeight: 600,
                                            cursor: "pointer"
                                        }}
                                    >
                                        Type <i className={`fa ${this.getSortIconClass("data_type")}`} />
                                    </button>
                                </th>
                                <th>
                                    <button
                                        type="button"
                                        onClick={() => this.handleSort("mrn")}
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            padding: 0,
                                            fontWeight: 600,
                                            cursor: "pointer"
                                        }}
                                    >
                                        MRN <i className={`fa ${this.getSortIconClass("mrn")}`} />
                                    </button>
                                </th>
                                <th style={{ width: "15%" }}>
                                    <button
                                        type="button"
                                        onClick={() => this.handleSort("fhir_patient_id")}
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            padding: 0,
                                            fontWeight: 600,
                                            cursor: "pointer"
                                        }}
                                    >
                                        FHIR Patient Id <i className={`fa ${this.getSortIconClass("fhir_patient_id")}`} />
                                    </button>
                                </th>
                                <th style={{ width: "10%" }} className="text-center">
                                    <button
                                        type="button"
                                        onClick={() => this.handleSort("processing_time_ms")}
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            padding: 0,
                                            fontWeight: 600,
                                            cursor: "pointer"
                                        }}
                                    >
                                        Duration <i className={`fa ${this.getSortIconClass("processing_time_ms")}`} />
                                    </button>
                                </th>
                                <th style={{ width: "10%" }} className="text-center">
                                    <button
                                        type="button"
                                        onClick={() => this.handleSort("file_size")}
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            padding: 0,
                                            fontWeight: 600,
                                            cursor: "pointer"
                                        }}
                                    >
                                        Size <i className={`fa ${this.getSortIconClass("file_size")}`} />
                                    </button>
                                </th>


                                <th className="text-center whitespace-nowrap">
                                    <button
                                        type="button"
                                        onClick={() => this.handleSort("Status")}
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            padding: 0,
                                            fontWeight: 600,
                                            cursor: "pointer"
                                        }}
                                    >
                                        Status <i className={`fa ${this.getSortIconClass("Status")}`} />
                                    </button>
                                </th>

                                <th className="text-center whitespace-nowrap">
                                    <button
                                        type="button"
                                        onClick={() => this.handleSort("created_date")}
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            padding: 0,
                                            fontWeight: 600,
                                            cursor: "pointer"
                                        }}
                                    >
                                        Created <i className={`fa ${this.getSortIconClass("created_date")}`} />
                                    </button>
                                </th>

                                <th className="text-center">
                                    <button
                                        type="button"
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            padding: 0,
                                            fontWeight: 600,
                                            cursor: "pointer"
                                        }}
                                    >
                                        EMPI
                                    </button>
                                </th>

                            </tr>
                        </thead>
                        <tbody>
                            {sortedList.map((ref, idx) => (
                                <tr
                                    key={idx}
                                    className="cursor-pointer"
                                    onClick={(e) => {
                                        // e.preventDefault();
                                        e.stopPropagation();
                                        this.handleSidebar(ref, 'detail');
                                    }}>
                                    <td>{ref.patient_name}</td>
                                    <td>{ref.channel_name}</td>
                                    <td>{ref.data_type}</td>
                                    <td>{ref.mrn}</td>
                                    <td>{ref.fhir_patient_id}</td>
                                    <td className="text-center">{formatDuration(ref.processing_time_ms)}</td>
                                    <td className="text-center">{formatFileSize(ref.file_size || 0)}</td>
                                    <td className="text-center">
                                        <span
                                            className="label"
                                            style={{
                                                backgroundColor: ref.Status == 1 ? "#11952b" : "#9f2626" || "#999",
                                                color: "#fff"
                                            }}
                                        >
                                            {ref.Status == 1 ? "Success" : "Failed"}
                                        </span>
                                    </td>
                                    <td className="text-center whitespace-nowrap">{formatDate(ref.created_date)}</td>
                                    <td className="text-center">
                                        <i className="fa fa-eye"
                                            style={{ cursor: "pointer" }}
                                            title="View EMPI"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                this.handleSidebar(ref, 'empi');
                                            }}
                                        />
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    formatNumber(value) {
        return Number(value || 0).toLocaleString("en-US");
    }

    groupData(data) {
        console.log("data", data);
        if (data == null) return;
        const result = {};

        data.forEach(item => {
            if (!result[item.data_type]) {
                result[item.data_type] = [];
            }
            result[item.data_type].push(item);
        });

        return result;
    }

    render() {
        const disablePrev = this.state.page == 0 ? true : false;
        const disableNext = (this.state.page >= this.state.totalPages - 1) || this.state.loading;
        const groupedData = this.groupData(this.state.stats);

        return (
            <>
                <div className="page">
                    <div className="app-header">
                        <Header2
                            query={this.props.query}
                            settings={this.props.settings}
                            location={this.props.location}
                            urlParams={this.props.urlParams}
                        />
                    </div>

                    <div className="patient-search-results">
                        <div className="panel-default">
                            <div className="panel-heading" style={{ padding: "10px 15px" }}>
                                <div className="row d-flex align-items-center">
                                    <div className="col-xs-4">
                                        <b className="text-primary">
                                            Audit Log

                                            <span style={{ marginLeft: "12px", color: "#505050", fontWeight: 400, fontSize: '12px' }}>
                                                Total:&nbsp;
                                                <span style={{ color: "#2d2b2b" }}>{this.formatNumber(this.state.summary?.total)}</span>
                                            </span>
                                            <span style={{ marginLeft: "12px", color: "#505050", fontWeight: 400, fontSize: '12px' }}>
                                                Success:&nbsp;
                                                <span style={{ color: "#2e7d32" }}>{this.formatNumber(this.state.summary?.success)}</span>
                                            </span>
                                            <span style={{ marginLeft: "12px", color: "#505050", fontWeight: 400, fontSize: '12px' }}>
                                                Failed:&nbsp;
                                                <span style={{ color: "#c62828" }}>{this.formatNumber(this.state.summary?.failed)}</span>
                                            </span>
                                            <span style={{ position: "absolute" }}>
                                                <i style={{
                                                    marginLeft: "12px",
                                                    color: "#0d6efd",
                                                    fontWeight: 600,
                                                    fontSize: "14px",
                                                    cursor: "pointer"
                                                }}
                                                    className="fa fa-bar-chart"
                                                    onClick={() => {
                                                        this.setState({
                                                            showStats: !this.state.showStats
                                                        })
                                                    }}
                                                    title="Show Stats"
                                                />

                                                <div style={{
                                                    color: "#454545",
                                                    fontWeight: 400,
                                                    fontSize: "10px",
                                                    cursor: "pointer",
                                                    position: "absolute",
                                                    left: "-1rem",
                                                    background: "white",
                                                    width: "200px",
                                                    top: "1.5rem",
                                                    boxShadow: "0px 1px 5px 1px #a5a4a4b8",
                                                    borderRadius: "5px",
                                                    display: this.state.showStats ? 'block' : 'none',
                                                    zIndex: 100000000000
                                                }}>
                                                    <table className="table table-bordered table-condensed m-0">
                                                        <thead>
                                                            <tr>
                                                                <th>Data Type</th>
                                                                <th>Status</th>
                                                                <th>Count</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.stats && this.state.stats.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td>{item.data_type}</td>
                                                                    <td>
                                                                        {item.status === 1 ? "Success ✅" : "Failed ❌"}
                                                                    </td>
                                                                    <td>{item.count}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </span>
                                        </b>
                                    </div>
                                    <div className="col-xs-8">
                                        {this.renderFilters()}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ padding: '15px' }}>
                            {this.renderLogsList()}
                            {this.state.sidebarView === 'detail' &&
                                <MirthXML
                                    query={this.props.query}
                                    settings={this.props.settings}
                                    location={this.props.location}
                                    urlParams={this.props.urlParams}
                                    selectedLog={this.state.selectedLog}
                                    onClose={this.handleCloseSidebar}
                                />
                            }
                            {this.state.sidebarView === 'empi' &&
                                <MirthEMPI
                                    query={this.props.query}
                                    settings={this.props.settings}
                                    location={this.props.location}
                                    urlParams={this.props.urlParams}
                                    selectedLog={this.state.selectedLog}
                                    onClose={this.handleCloseSidebar}
                                />
                            }

                        </div>
                        <br />
                        <div className="app-footer" style={{ position: "fixed", bottom: 0, width: "100%" }}>
                            <div className="container-fluid" style={{ width: "100%" }}>
                                <div className="row">
                                    <div className="col-xs-3 col-sm-4 text-right">
                                        <a
                                            href="#prev"
                                            onClick={e => {
                                                e.preventDefault();
                                                this.handlePrev();
                                            }}
                                            className={disablePrev ? "disabled" : ""}
                                        >
                                            <i className="fa fa-arrow-left" /> Prev
                                        </a>
                                    </div>
                                    <div className="col-xs-6 col-sm-4 text-center">
                                        {/* { msg } */}
                                    </div>
                                    <div className="col-xs-3 col-sm-4 text-left">
                                        <a
                                            href="#next"
                                            onClick={e => {
                                                e.preventDefault();
                                                this.handleNext();
                                            }}
                                            className={disableNext ? "disabled" : ""}
                                        >
                                            Next <i className="fa fa-arrow-right" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </>
        );
    }
}

export default connect(state => state)(withRouter(MirthAuditLog));
